import React, { useEffect } from "react"
import types from "prop-types"
import removeQueryStringFromLocation from "utils/removeQueryStringFromLocation"
import CategoryList from "./CategoryList"

const PublicCategoryList = ({ categories }) => {
  useEffect(() => { removeQueryStringFromLocation() }, [])

  return (
    <div>
      <div className="text-lg text-center text-gray">Welcome!</div>
      <div className="pb-6 text-2xl sm:text-4xl mx-6 font-medium text-center">
        What would you like to do today?
      </div>
      <CategoryList categories={categories} />
    </div>
  )
}

PublicCategoryList.propTypes = {
  categories: types.arrayOf(types.object).isRequired,
}

export default PublicCategoryList
